const getContract = () => null

export const getBep20Contract = () => getContract()
export const getLpContract = () => getContract()
export const getCakeContract = () => getContract()
export const getMasterchefContract = () => getContract()
export const getSouschefContract = () => getContract()
export const getSouschefV2Contract = () => getContract()
export const getCakeVaultContract = () => getContract()
export const getMulticallContract = () => getContract()
